export async function fetchAllPages<T>(
  fetchPage: (skip: number, limit: number) => Promise<T[]>,
  pageSize: number
): Promise<T[]> {
  const items: T[] = []

  while (true) {
    const page = await fetchPage(items.length, pageSize)
    items.push(...page)

    if (page.length < pageSize) {
      return items
    }
  }
}
